import { FC } from 'react'
import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { ContainedButton } from '../styled'
import './style.scss'

interface DocInTinyMceProps {
  handleClosePopup: () => void
  articleLink: string
}

const EditDocument: FC<DocInTinyMceProps> = ({ handleClosePopup, articleLink }) => {

  return (
    <div className='article-link-container'>
      <DialogTitle>
        <div className='document-header'>Here is your article link</div>
      </DialogTitle>
      <DialogContent className='doc-article-body-container'>
        <a href={articleLink} target="_blank">{articleLink}</a>
      </DialogContent>
      <DialogActions>
        <div className='dialog-action-container'>
          <ContainedButton onClick={handleClosePopup}>
            Done
          </ContainedButton>
        </div>
      </DialogActions>
    </div>
  )
}

export default EditDocument